import { defineMessages } from 'react-intl';

export const workspaceSelectorMessages = defineMessages({
  heading: {
    defaultMessage: 'Where to today?',
    id: 'JDW8tdh87Z',
    description: 'Heading of the post-login screen asking which workspace to enter',
  },
  subheading: {
    defaultMessage: 'Select a workspace to get started',
    id: 'lR032hiiBf',
    description: 'Guidance under the post-login workspace selector heading',
  },
  workspaceListLabel: {
    defaultMessage: 'Your workspaces',
    id: 'GTugFGq/Ud',
    description: 'Accessible name of the list of workspaces on the post-login selector',
  },
  workspaceAndInvitesListLabel: {
    defaultMessage: 'Your workspaces and invites',
    id: '5Pmjc5DRkH',
    description:
      'Accessible name of the merged workspaces/invitations list on the post-login selector, used once pending invitations are present so assistive technology does not announce them as existing memberships',
  },
  invitationCaption: {
    defaultMessage: 'Sent you a workspace invite',
    id: 'DFJEDfH/xH',
    description:
      'Caption under a pending workspace invitation on the post-login selector',
  },
  joinTeam: {
    defaultMessage: 'Join team',
    id: '8MREJ65uYn',
    description:
      'Button that accepts a pending workspace invitation on the post-login selector',
  },
  joining: {
    defaultMessage: 'Joining…',
    id: 'SmiRl7uGQU',
    description: 'Label of the join button while the invitation is being accepted',
  },
  joinFailed: {
    defaultMessage: "Couldn't join this workspace. Try again.",
    id: '5ngoJmErDa',
    description: 'Inline error under a pending invitation whose accept request failed',
  },
  signOut: {
    defaultMessage: 'Sign out',
    id: 'MfuPeWVQ26',
    description:
      'Button in the post-login workspace selector footer that signs the user out',
  },
});
